import { BElement } from 'utils/base-component'

export class MobileDropdowns {
  private cssClass: string
  private exploreBtn: BElement
  private exploreDropdown: BElement
  private accountBtn: BElement
  private accountDropdown: BElement
  private settingsBtn: BElement
  private settingsDropdown: BElement

  constructor(cssClass: string) {
    this.cssClass = cssClass
    this.initializeElements()
    this.initializeDropdownStates()
    this.addEventListeners()
  }

  private initializeElements() {
    const exploreBtn = document.querySelector('.menu-nav__button--explore')
    // console.log('Explore button found:', exploreBtn) // Debug line
    this.exploreBtn = new BElement(exploreBtn, this.cssClass)

    const exploreDropdown = document.querySelector('.menu-nav__explore-dropdown')
    // console.log('Explore dropdown found:', exploreDropdown) // Debug line
    this.exploreDropdown = new BElement(exploreDropdown, this.cssClass)

    const accountBtn = document.querySelector('.menu-nav__button--account')
    // console.log('Account button found:', accountBtn) // Debug line
    this.accountBtn = new BElement(accountBtn, this.cssClass)

    const accountDropdown = document.querySelector('.menu-nav__account-dropdown')
    // console.log('Account dropdown found:', accountDropdown) // Debug line
    this.accountDropdown = new BElement(accountDropdown, this.cssClass)

    const settingsBtn = document.querySelector('.menu-nav__button--settings')
    // console.log('Settings button found:', settingsBtn) // Debug line
    this.settingsBtn = new BElement(settingsBtn, this.cssClass)

    const settingsDropdown = document.querySelector('.menu-nav__settings-dropdown')
    // console.log('Settings dropdown found:', settingsDropdown) // Debug line
    this.settingsDropdown = new BElement(settingsDropdown, this.cssClass)
  }

  private initializeDropdownStates() {
    // Set initial dropdown state
    if (this.exploreBtn.element) {
      this.exploreBtn.element.setAttribute('aria-expanded', 'true')
      this.exploreDropdown.element?.classList.add('active')
    }
    if (this.accountBtn.element) {
      this.accountBtn.element.setAttribute('aria-expanded', 'false')
    }
    if (this.settingsBtn.element) {
      this.settingsBtn.element.setAttribute('aria-expanded', 'false')
    }
  }

  private addEventListeners() {
    if (this.exploreBtn.element) {
      this.exploreBtn.element.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleDropdown(this.exploreDropdown, this.exploreBtn)
      })
    }

    if (this.accountBtn.element) {
      this.accountBtn.element.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleDropdown(this.accountDropdown, this.accountBtn)
      })
    }

    if (this.settingsBtn.element) {
      this.settingsBtn.element.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleDropdown(this.settingsDropdown, this.settingsBtn)
      })
    }
  }

  private toggleDropdown(dropdown: BElement, button: BElement): void {
    if (!dropdown?.element || !button?.element) return

    const dropdownElement = dropdown.element
    const buttonElement = button.element
    const isExpanded = buttonElement.getAttribute('aria-expanded') === 'true'

    // first close all dropdowns
    this.closeAllDropdowns(dropdown)

    // Toggle dropdown state
    if (isExpanded) {
      dropdownElement.classList.remove('active')
      buttonElement.setAttribute('aria-expanded', 'false')
      const arrowIcon = buttonElement.querySelector('.menu-nav__down-arrow-icon')
      if (arrowIcon) {
        arrowIcon.classList.remove('active')
      }
    } else {
      dropdownElement.classList.add('active')
      buttonElement.setAttribute('aria-expanded', 'true')
      const arrowIcon = buttonElement.querySelector('.menu-nav__down-arrow-icon')
      if (arrowIcon) {
        arrowIcon.classList.add('active')
      }
    }
  }

  // Public method to check if click is inside dropdowns
  isDropdownClick(target: Node): boolean {
    return (
      (this.exploreDropdown.element && this.exploreDropdown.element.contains(target)) ||
      (this.accountDropdown.element && this.accountDropdown.element.contains(target)) ||
      (this.settingsDropdown.element && this.settingsDropdown.element.contains(target))
    )
  }

  // Public method to check if click is on dropdown buttons
  isDropdownButtonClick(target: Node): boolean {
    return (
      (this.exploreBtn.element && this.exploreBtn.element.contains(target)) ||
      (this.accountBtn.element && this.accountBtn.element.contains(target)) ||
      (this.settingsBtn.element && this.settingsBtn.element.contains(target))
    )
  }

  // Public method to close all dropdowns
  closeAllDropdowns(exceptDropdown?: BElement): void {
    const dropdowns = [
      { dropdown: this.exploreDropdown, button: this.exploreBtn },
      { dropdown: this.accountDropdown, button: this.accountBtn },
      { dropdown: this.settingsDropdown, button: this.settingsBtn }
    ]

    dropdowns.forEach(({ dropdown, button }) => {
      if (exceptDropdown && dropdown === exceptDropdown) return

      if (dropdown?.element && button?.element) {
        if (dropdown.element.classList.contains('active')) {
          dropdown.element.classList.remove('active')
          button.element.setAttribute('aria-expanded', 'false')
        }

        const arrowIcon = button.element.querySelector('.menu-nav__down-arrow-icon')
        if (arrowIcon) {
          arrowIcon.classList.remove('active')
        }
      }
    })
  }
}
